<template>
    <BarGroup/>
</template>

<script>
// @ is an alias to /src
import BarGroup from '@/components/BarGroup.vue'

export default {
  name: 'barGroup',
  components: {
    BarGroup
  }
}
</script>
